const { defineMessages } = require('@sm/intl');

export const TYPE_HEADER = '[Type: Header][Vis: high] - Feature Set List Item Tooltip Heading';
export const TYPE_PARAGRAPH = '[Type: Paragraph][Vis: high] - Feature Set List Item Tooltip';
const NUM_RESPONSES = 'Number of responses';
const NUM_RESPONSES_TOOLTIP =
  'Each plan has a limited number of responses as indicated. Basic users must purchase a paid plan to view responses in excess of the Response Limit. For other plans, users will be invoiced up to US$0.80 cent or equivalent, for each response over the indicated Response Limit.';
const SUPPORT = '24/7 Customer support via email';
const SUPPORT_TOOLTIP =
  'We offer 24/7 email support for all customers. Emails from ADVANTAGE and PREMIER customers are prioritized to receive responses as quickly as possible. We also offer phone support for our PREMIER customers.';
const CONTRIBUTOR_SEATS = 'Contributor seats';
const CONTRIBUTOR_SEATS_TOOLTIP =
  'While purchasing a team plan, you can add Contributor seats as a cost-effective way to include more stakeholders to analyze survey results. Contributors can use SurveyMonkey analysis features but cannot create or send surveys. Full Users on your team can share surveys with Contributors.';
const SENTIMENT_ANALYSIS = 'Sentiment analysis';
const SENTIMENT_ANALYSIS_TOOLTIP = `We'll automatically label your text responses as positive, neutral, or negative to reveal the emotion behind what people are saying.`;
const DATA_EXPORTS = 'Data exports';
const DATA_EXPORTS_TOOLTIP = `Create and print custom charts and reports quickly and easily. You'll be able to download survey results in several file formats, including as CSV, PDF, PPT, or XLS files. Export for SPSS for Advantage and Premier members.`;
const ADVANCED_LOGIC = 'Advanced survey logic';
const ADVANCED_LOGIC_TOOLTIP =
  'Enhance your survey data with access to advanced branching, advanced piping, block randomization, quotas, and more. Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.';

export default defineMessages({
  a_b_testing_tooltip_heading: {
    id: 'PricingSummary.Feature.ABTestingTooltipHeading',
    defaultMessage: 'A/B test question type',
    desc: TYPE_HEADER,
  },
  a_b_testing_tooltip: {
    id: 'PricingSummary.Feature.ABTestingTooltip',
    defaultMessage:
      'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text.',
    desc: TYPE_PARAGRAPH,
  },
  account_control_tooltip_heading: {
    id: 'PricingSummary.Feature.AccountControlTooltipHeading',
    defaultMessage: 'Account control',
    desc: TYPE_HEADER,
  },
  account_control_tooltip: {
    id: 'PricingSummary.Feature.AccountControlTooltip',
    defaultMessage: `Automate onboarding users. Seamlessly enable new users to sign up or migrate existing users into your organization's SurveyMonkey Enterprise account.`,
    desc: TYPE_PARAGRAPH,
  },
  account_verification_tooltip_heading: {
    id: 'PricingSummary.Feature.AccountVerificationTooltipHeading',
    defaultMessage: 'Account Verification Heading',
    desc: TYPE_HEADER,
  },
  account_verification_tooltip: {
    id: 'PricingSummary.Feature.AccountVerificationTooltip',
    defaultMessage: 'Account Verification tooltip',
    desc: TYPE_PARAGRAPH,
  },
  add_users_tooltip_heading: {
    id: 'PricingSummary.Feature.AddUsersTooltipHeading',
    defaultMessage: 'Additional Full User accounts',
    desc: TYPE_HEADER,
  },
  add_users_tooltip: {
    id: 'PricingSummary.Feature.AddUsersTooltip',
    defaultMessage: `Business plans start at 3 Full Users, and allow you to invite more Full Users to your SurveyMonkey team for an additional fee. While purchasing a plan with a minimum of 3 users, you can add Contributor seats in bundles of 2 as a cost-effective way to add stakeholders to focus solely on analyzing survey results. <a href="/mp/collaboration/?ut_source=pricing-details" target="_top">Learn More »</a>`,
    desc: TYPE_PARAGRAPH,
  },
  admin_dashboard_tooltip_heading: {
    id: 'PricingSummary.Feature.AdminDashboardTooltipHeading',
    defaultMessage: 'Admin dashboard',
    desc: TYPE_HEADER,
  },
  admin_dashboard_tooltip: {
    id: 'PricingSummary.Feature.AdminDashboardTooltip',
    defaultMessage: `Get visibility into your team's activity. View usage metrics like the number of surveys each user has in their account, and the date of their last login. You can also preview surveys in each account too.`,
    desc: TYPE_PARAGRAPH,
  },
  advanced_analyze_features_tooltip_heading: {
    id: 'PricingSummary.Feature.AdvancedAnalyzeFeaturesTooltipHeading',
    defaultMessage: 'Advanced survey analysis',
    desc: TYPE_HEADER,
  },
  advanced_analyze_features_tooltip: {
    id: 'PricingSummary.Feature.AdvancedAnalyzeFeaturesTooltip',
    defaultMessage:
      'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: TYPE_PARAGRAPH,
  },
  advanced_collaboration_tooltip_heading: {
    id: 'PricingSummary.Feature.AdvancedCollaborationTooltipHeading',
    defaultMessage: CONTRIBUTOR_SEATS,
    desc: TYPE_HEADER,
  },
  advanced_collaboration_tooltip: {
    id: 'PricingSummary.Feature.AdvancedCollaborationTooltip',
    defaultMessage: CONTRIBUTOR_SEATS_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  advanced_logic_tooltip_heading: {
    id: 'PricingSummary.Feature.AdvancedLogicTooltipHeading',
    defaultMessage: ADVANCED_LOGIC,
    desc: TYPE_HEADER,
  },
  advanced_logic_tooltip: {
    id: 'PricingSummary.Feature.AdvancedLogicTooltip',
    defaultMessage: ADVANCED_LOGIC_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  all_data_exports_tooltip_heading: {
    id: 'PricingSummary.Feature.AllDataExportsTooltipHeading',
    defaultMessage: DATA_EXPORTS,
    desc: TYPE_HEADER,
  },
  all_data_exports_tooltip: {
    id: 'PricingSummary.Feature.AllDataExportsTooltip',
    defaultMessage: DATA_EXPORTS_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  all_languages_supported_tooltip_heading: {
    id: 'PricingSummary.Feature.AllLanguagesSupportedTooltipHeading',
    defaultMessage: 'All languages supported',
    desc: TYPE_HEADER,
  },
  all_languages_supported_tooltip: {
    id: 'PricingSummary.Feature.AllLanguagesSupportedTooltip',
    defaultMessage:
      'Create surveys in any language. You can write in unicode or multi-byte languages, and choose navigation buttons, help text, and error messages from 58 languages.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_access_benchmarking_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeAccessBenchmarkingTooltipHeading',
    defaultMessage: 'Analyze Access Benchmarking Heading',
    desc: TYPE_HEADER,
  },
  analyze_access_benchmarking_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeAccessBenchmarkingTooltip',
    defaultMessage: 'Analyze Access Benchmarking tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_export_ta_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanExportTATooltipHeading',
    defaultMessage: 'Analyze Export TA Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_export_ta_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanExportTATooltip',
    defaultMessage: 'Analyze Export TA tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_save_views_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanSaveViewsTooltipHeading',
    defaultMessage: 'Analyze Save Views Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_save_views_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanSaveViewsTooltip',
    defaultMessage: 'Analyze Save Views tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_share_customize_branding_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeBrandingTooltipHeading',
    defaultMessage: 'Customization and branding',
    desc: TYPE_HEADER,
  },
  analyze_can_share_customize_branding_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeBrandingTooltip',
    defaultMessage:
      'Ensure a consistent brand experience for all survey-takers and enjoy customization features like Custom Subdomain, Custom Terms of Use and Custom Question Bank.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_share_customize_domain_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeDomainTooltipHeading',
    defaultMessage: 'Analyze Share Customize Domain Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_share_customize_domain_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeDomainTooltip',
    defaultMessage: 'Analyze Share Customize Domain tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_ta_search_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanTASearchTooltipHeading',
    defaultMessage: 'Analyze TA Search Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_ta_search_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanTASearchTooltip',
    defaultMessage: 'Analyze TA Search tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_ta_tag_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanTATagTooltipHeading',
    defaultMessage: 'Tag written answers',
    desc: TYPE_HEADER,
  },
  analyze_can_ta_tag_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanTATagTooltip',
    defaultMessage:
      'Tag written answers to organize them by topic and uncover trends. See the percentage of answers that include each tag.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_combine_filters_tooltip_heading: {
    id: 'PricingSummary.Feature.CombineFiltersTooltipHeading',
    defaultMessage: 'Filter and compare rules',
    desc: TYPE_HEADER,
  },
  analyze_combine_filters_tooltip: {
    id: 'PricingSummary.Feature.CombineFiltersTooltip',
    defaultMessage:
      'Use filter and compare rules to segment your data and discover hidden trends. With a Basic plan, you can apply and save one rule to your data, but paid plans allow you to save and apply an unlimited number of rules. Data trends let you see how your results have changed over time.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_dashboard_password_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeDashboardPasswordEnabledTooltipHeading',
    defaultMessage: 'Dashboard: Password protection',
    desc: TYPE_HEADER,
  },
  analyze_dashboard_password_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeDashboardPasswordEnabledTooltip',
    defaultMessage: 'Set a password for your dashboards for share more securely.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_delete_respondent_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeDeleteRespondentLimitTooltipHeading',
    defaultMessage: 'Analyze Delete Respondent Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_delete_respondent_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeDeleteRespondentLimitTooltip',
    defaultMessage: 'Analyze Delete Respondent Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_export_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeExportEnabledTooltipHeading',
    defaultMessage: DATA_EXPORTS,
    desc: TYPE_HEADER,
  },
  analyze_export_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeExportEnabledTooltip',
    defaultMessage: DATA_EXPORTS_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  analyze_export_spss_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeExportSpssEnabledTooltipHeading',
    defaultMessage: 'Advanced data exports',
    desc: TYPE_HEADER,
  },
  analyze_export_spss_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeExportSpssEnabledTooltip',
    defaultMessage:
      'Download your survey results into SPSS-along with CSV, PDF, PPT, or XLS files too. Also create and print custom charts and reports quickly and easily.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_integrations_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeIntegrationsTooltipHeading',
    defaultMessage: 'Integrations',
    desc: TYPE_HEADER,
  },
  analyze_integrations_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeIntegrationsTooltip',
    defaultMessage: `SurveyMonkey integrates with popular apps like Office 365, Google Drive, and Slack, so it's easy to use with your existing workflows.`,
    desc: TYPE_PARAGRAPH,
  },
  analyze_password_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzePasswordEnabledTooltipHeading',
    defaultMessage: 'Analyze Password Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_password_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzePasswordEnabledTooltip',
    defaultMessage: 'Analyze Password Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_response_delete_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeResponseDeleteLimitTooltipHeading',
    defaultMessage: 'Analyze Response Delete Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_response_delete_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeResponseDeleteLimitTooltip',
    defaultMessage: 'Analyze Response Delete Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_response_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeResponseLimitTooltipHeading',
    defaultMessage: 'Analyze Response Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_response_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeResponseLimitTooltip',
    defaultMessage: 'Analyze Response Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_results_together_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeResultsTogetherTooltipHeading',
    defaultMessage: 'Analyze results together',
    desc: TYPE_HEADER,
  },
  analyze_results_together_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeResultsTogetherTooltip',
    defaultMessage: 'Give your team access to survey results and export tools.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_rule_based_tagging_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeRuleBasedTaggingTooltipHeading',
    defaultMessage: 'Analyze Rule Based Tagging Heading',
    desc: TYPE_HEADER,
  },
  analyze_rule_based_tagging_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeRuleBasedTaggingTooltip',
    defaultMessage: 'Analyze Rule Based Tagging tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_rule_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeRuleLimitTooltipHeading',
    defaultMessage: 'Analyze Rule Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_rule_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeRuleLimitTooltip',
    defaultMessage: 'Analyze Rule Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_sentiment_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabledTooltipHeading',
    defaultMessage: SENTIMENT_ANALYSIS,
    desc: TYPE_HEADER,
  },
  analyze_sentiment_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabledTooltip',
    defaultMessage: SENTIMENT_ANALYSIS_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  sentiment_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabledTooltipHeading',
    defaultMessage: SENTIMENT_ANALYSIS,
    desc: TYPE_HEADER,
  },
  sentiment_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabledTooltip',
    defaultMessage: SENTIMENT_ANALYSIS_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  analyze_shared_results_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeSharedResultsEnabledTooltipHeading',
    defaultMessage: 'Analyze Shared Results Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_shared_results_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeSharedResultsEnabledTooltip',
    defaultMessage: 'Analyze Shared Results Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_ta_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeTAEnabledTooltipHeading',
    defaultMessage: 'Word clouds',
    desc: TYPE_HEADER,
  },
  analyze_ta_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeTAEnabledTooltip',
    defaultMessage:
      'Quickly spot trends and common themes in written answers. Words with lots of mentions appear bigger so you can get a quick understanding of what matters most to your respondents.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_trends_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeTrendsEnabledTooltipHeading',
    defaultMessage: 'Data trends',
    desc: TYPE_HEADER,
  },
  analyze_trends_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeTrendsEnabledTooltip',
    defaultMessage: 'View your results trended over time to spot changes when they happen.',
    desc: TYPE_PARAGRAPH,
  },
  api_access_tooltip_heading: {
    id: 'PricingSummary.Feature.ApiAccessTooltipHeading',
    defaultMessage: 'API Access Heading',
    desc: TYPE_HEADER,
  },
  api_access_tooltip: {
    id: 'PricingSummary.Feature.ApiAccessTooltip',
    defaultMessage: 'API Access tooltip',
    desc: TYPE_PARAGRAPH,
  },
  asset_library_tooltip_heading: {
    id: 'PricingSummary.Feature.AssetLibraryTooltipHeading',
    defaultMessage: 'Asset Library Heading',
    desc: TYPE_HEADER,
  },
  asset_library_tooltip: {
    id: 'PricingSummary.Feature.AssetLibraryTooltip',
    defaultMessage: 'Asset Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  assign_admin_role_tooltip_heading: {
    id: 'PricingSummary.Feature.AssignAdminRoleTooltipHeading',
    defaultMessage: 'Assign Admin Role Heading',
    desc: TYPE_HEADER,
  },
  assign_admin_role_tooltip: {
    id: 'PricingSummary.Feature.AssignAdminRoleTooltip',
    defaultMessage: 'Assign Admin Role tooltip',
    desc: TYPE_PARAGRAPH,
  },
  base_response_count_tooltip_heading: {
    id: 'PricingSummary.Feature.BaseResponseCountTooltipHeading',
    defaultMessage: NUM_RESPONSES,
    desc: TYPE_HEADER,
  },
  base_response_count_tooltip: {
    id: 'PricingSummary.Feature.BaseResponseCountTooltip',
    defaultMessage: NUM_RESPONSES_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  benchmarks_tooltip_heading: {
    id: 'PricingSummary.Feature.BenchmarksTooltipHeading',
    defaultMessage: 'SurveyMonkey industry benchmarks',
    desc: TYPE_HEADER,
  },
  benchmarks_tooltip: {
    id: 'PricingSummary.Feature.BenchmarksTooltip',
    defaultMessage: `Compare your results against the Industry Benchmark to understand how you're doing in the context of your greater industry. See your results in context to see how you measure up against your peers.`,
    desc: TYPE_PARAGRAPH,
  },
  best_worst_qt_tooltip_heading: {
    id: 'PricingSummary.Feature.BestWorstQTTooltipHeading',
    defaultMessage: 'Best Worst QT Heading',
    desc: TYPE_HEADER,
  },
  best_worst_qt_tooltip: {
    id: 'PricingSummary.Feature.BestWorstQTTooltip',
    defaultMessage: 'Best Worst QT tooltip',
    desc: TYPE_PARAGRAPH,
  },
  block_randomization_tooltip_heading: {
    id: 'PricingSummary.Feature.BlockRandomizationTooltipHeading',
    defaultMessage: 'Block randomization',
    desc: TYPE_HEADER,
  },
  block_randomization_tooltip: {
    id: 'PricingSummary.Feature.BlockRandomizationTooltip',
    defaultMessage:
      'Blocks are groups of pages, where each group contains related questions about a particular concept you want to test. You can use block randomization logic to rotate, flip, or randomize blocks to minimize order bias.',
    desc: TYPE_PARAGRAPH,
  },
  build_surveys_together_tooltip_heading: {
    id: 'PricingSummary.Feature.BuildSurveysTogetherTooltipHeading',
    defaultMessage: 'Build surveys together',
    desc: TYPE_HEADER,
  },
  build_surveys_together_tooltip: {
    id: 'PricingSummary.Feature.BuildSurveysTogetherTooltip',
    defaultMessage: 'Let people on your team view, edit, or comment on your surveys.',
    desc: TYPE_PARAGRAPH,
  },
  bulk_survey_share_tooltip_heading: {
    id: 'PricingSummary.Feature.BulkSurveyShareTooltipHeading',
    defaultMessage: 'Bulk Survey Share Heading',
    desc: TYPE_HEADER,
  },
  bulk_survey_share_tooltip: {
    id: 'PricingSummary.Feature.BulkSurveyShareTooltip',
    defaultMessage: 'Bulk Survey Share tooltip',
    desc: TYPE_PARAGRAPH,
  },
  bulk_survey_transfer_tooltip_heading: {
    id: 'PricingSummary.Feature.BulkSurveyTransferTooltipHeading',
    defaultMessage: 'Bulk Survey Transfer Heading',
    desc: TYPE_HEADER,
  },
  bulk_survey_transfer_tooltip: {
    id: 'PricingSummary.Feature.BulkSurveyTransferTooltip',
    defaultMessage: 'Bulk Survey Transfer tooltip',
    desc: TYPE_PARAGRAPH,
  },
  carry_forward_tooltip_heading: {
    id: 'PricingSummary.Feature.CarryForwardTooltipHeading',
    defaultMessage: 'Carry forward responses',
    desc: TYPE_HEADER,
  },
  carry_forward_tooltip: {
    id: 'PricingSummary.Feature.CarryForwardTooltip',
    defaultMessage: `Use each respondent's previous answer choices in a related question that appears later in your survey. You can carry forward either a respondent's selected or unselected answer choices and choose to show all or some previously selected or unselected answers. Responses that are carried forward cannot be edited.`,
    desc: TYPE_PARAGRAPH,
  },
  click_map_qt_tooltip_heading: {
    id: 'PricingSummary.Feature.ClickMapQTTooltipHeading',
    defaultMessage: 'Click map data visualization',
    desc: TYPE_HEADER,
  },
  click_map_qt_tooltip: {
    id: 'PricingSummary.Feature.ClickMapQTTooltip',
    defaultMessage: `Collect feedback on an image by tracking where and how many respondents click on it. When analyzing and presenting results, you'll be able to see each click represented by a corresponding dot, so it's clear which areas stand out to your audience.`,
    desc: TYPE_PARAGRAPH,
  },
  collaboration_tooltip_heading: {
    id: 'PricingSummary.Feature.CollaborationTooltipHeading',
    defaultMessage: 'Advanced permissions',
    desc: TYPE_HEADER,
  },
  collaboration_tooltip: {
    id: 'PricingSummary.Feature.CollaborationTooltip',
    defaultMessage: 'Collaborate with fine control over who can view and edit your survey projects.',
    desc: TYPE_PARAGRAPH,
  },
  collaborate_tooltip_heading: {
    id: 'PricingSummary.Feature.CollaborateTooltipHeading',
    defaultMessage: 'Build surveys together',
    desc: TYPE_HEADER,
  },
  collaborate_tooltip: {
    id: 'PricingSummary.Feature.CollaborateTooltip',
    defaultMessage: 'Let people on your team view, edit, or comment on your surveys.',
    desc: TYPE_PARAGRAPH,
  },
  collect_email_throttle_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectEmailThrottleLimitTooltipHeading',
    defaultMessage: 'Collect Email Throttle Limit Heading',
    desc: TYPE_HEADER,
  },
  collect_email_throttle_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectEmailThrottleLimitTooltip',
    defaultMessage: 'Collect Email Throttle Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_min_daily_messages_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectMinDailyMessagesLimitTooltipHeading',
    defaultMessage: 'Collect Min Daily Messages Limit Heading',
    desc: TYPE_HEADER,
  },
  collect_min_daily_messages_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectMinDailyMessagesLimitTooltip',
    defaultMessage: 'Collect Min Daily Messages Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectResponsesTooltipHeading',
    defaultMessage: 'Collect Responses Heading',
    desc: TYPE_HEADER,
  },
  collect_responses_tooltip: {
    id: 'PricingSummary.Feature.CollectResponsesTooltip',
    defaultMessage: 'Collect Responses tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_completion_url_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorCompletionUrlEnabledTooltipHeading',
    defaultMessage: 'Survey completion redirect',
    desc: TYPE_HEADER,
  },
  collector_completion_url_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorCompletionUrlEnabledTooltip',
    defaultMessage:
      'For a customized experience, redirect survey respondents to your website once they complete your survey.',
    desc: TYPE_PARAGRAPH,
  },
  collector_contact_list_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorContactListLimitTooltipHeading',
    defaultMessage: 'Collector Contact List Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_contact_list_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorContactListLimitTooltip',
    defaultMessage: 'Collector Contact List Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_create_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorCreateLimitTooltipHeading',
    defaultMessage: 'Number of collectors',
    desc: TYPE_HEADER,
  },
  collector_create_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorCreateLimitTooltip',
    defaultMessage:
      'Collectors are ways you can send your survey to respondents. Our collector types include weblinks, email, embedding on your website, and more.',
    desc: TYPE_PARAGRAPH,
  },
  collector_email_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorEmailLimitTooltipHeading',
    defaultMessage: 'Collector Email Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_email_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorEmailLimitTooltip',
    defaultMessage: 'Collector Email Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_email_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorEmailEnabledTooltipHeading',
    defaultMessage: 'Collector Email Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_email_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorEmailEnabledTooltip',
    defaultMessage: 'Collector Email Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_facebook_messenger_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorFacebookMessengerEnabledTooltipHeading',
    defaultMessage: 'Collector Facebook Messenger Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_facebook_messenger_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorFacebookMessengerEnabledTooltip',
    defaultMessage: 'Collector Facebook Messenger Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_manual_data_entry_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorManualDataEntryEnabledTooltipHeading',
    defaultMessage: 'Collector Manuanl Data Entry Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_manual_data_entry_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorManualDataEntryEnabledTooltip',
    defaultMessage: 'Collector Manuanl Data Entry Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_mobile_sdk_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorMobileSdkEnabledTooltipHeading',
    defaultMessage: 'Mobile SDK',
    desc: TYPE_HEADER,
  },
  collector_mobile_sdk_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorMobileSdkEnabledTooltip',
    defaultMessage: 'Integrate surveys directly into your iOS and Android mobile app.',
    desc: TYPE_PARAGRAPH,
  },
  collector_offline_kiosk_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorOfflineKioskEnabledTooltipHeading',
    defaultMessage: 'Collector Offline Kiosk Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_offline_kiosk_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorOfflineKioskEnabledTooltip',
    defaultMessage: 'Collector Offline Kiosk Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_popup_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorPopupEnabledTooltipHeading',
    defaultMessage: 'Collector Popup Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_popup_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorPopupEnabledTooltip',
    defaultMessage: 'Collector Popup Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_friendly_url_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorFriendlyUrlEnabledTooltipHeading',
    defaultMessage: 'Custom SurveyMonkey URL',
    desc: TYPE_HEADER,
  },
  collector_friendly_url_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorFriendlyUrlEnabledTooltip',
    defaultMessage: 'Write customized survey URLs, for example: http://www.surveymonkey.com/s/your-survey',
    desc: TYPE_PARAGRAPH,
  },
  collector_max_responses_delete_count_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorMaxResponsesDeleteCountTooltipHeading',
    defaultMessage: 'Collector Max Responses Delete Count Heading',
    desc: TYPE_HEADER,
  },
  collector_max_responses_delete_count_tooltip: {
    id: 'PricingSummary.Feature.CollectorMaxResponsesDeleteCountTooltip',
    defaultMessage: 'Collector Max Responses Delete Count tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_recipients_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorRecipientsLimitTooltipHeading',
    defaultMessage: 'Collector Recipients Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_recipients_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorRecipientsLimitTooltip',
    defaultMessage: 'Collector Recipients Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_white_label_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorWhiteLabelEnabledTooltipHeading',
    defaultMessage: 'White label surveys',
    desc: TYPE_HEADER,
  },
  collector_white_label_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorWhiteLabelEnabledTooltip',
    defaultMessage:
      'Completely customize and brand your surveys. Remove the SurveyMonkey footer from your surveys, change the domain of your survey link to research.net, and redirect survey respondents to your site upon survey completion.',
    desc: TYPE_PARAGRAPH,
  },
  collector_zoom_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorZoomEnabledTooltipHeading',
    defaultMessage: 'Collector Zoom Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_zoom_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorZoomEnabledTooltip',
    defaultMessage: 'Collector Zoom Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collectors_read_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorsReadTooltipHeading',
    defaultMessage: 'Collectors Read Heading',
    desc: TYPE_HEADER,
  },
  collectors_read_tooltip: {
    id: 'PricingSummary.Feature.CollectorsReadTooltip',
    defaultMessage: 'Collectors Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collectors_write_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorsWriteTooltipHeading',
    defaultMessage: 'Collectors Write Heading',
    desc: TYPE_HEADER,
  },
  collectors_write_tooltip: {
    id: 'PricingSummary.Feature.CollectorsWriteTooltip',
    defaultMessage: 'Collectors Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_end_page_question_bank_demographics_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectEndPageQuestionBankDemographicsTooltipHeading',
    defaultMessage: 'Collect End Page Question Bank Demographics Heading',
    desc: TYPE_HEADER,
  },
  collect_end_page_question_bank_demographics_tooltip: {
    id: 'PricingSummary.Feature.CollectEndPageQuestionBankDemographicsTooltip',
    defaultMessage: 'Collect End Page Question Bank Demographics tooltip',
    desc: TYPE_PARAGRAPH,
  },
  comment_box_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.CommentBoxQuestionTypeTooltipHeading',
    defaultMessage: 'Comment Box Question Type Heading',
    desc: TYPE_HEADER,
  },
  comment_box_question_type_tooltip: {
    id: 'PricingSummary.Feature.CommentBoxQuestionTypeTooltip',
    defaultMessage: 'Comment Box Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  consolidated_billing_tooltip_heading: {
    id: 'PricingSummary.Feature.ConsolidatedBillingTooltipHeading',
    defaultMessage: 'Consolidated billing',
    desc: TYPE_HEADER,
  },
  consolidated_billing_tooltip: {
    id: 'PricingSummary.Feature.ConsolidatedBillingTooltip',
    defaultMessage: 'Receive a consolidated bill for your entire team in SurveyMonkey.',
    desc: TYPE_PARAGRAPH,
  },
  contacts_read_tooltip_heading: {
    id: 'PricingSummary.Feature.ContactsReadTooltipHeading',
    defaultMessage: 'Contacts Read Heading',
    desc: TYPE_HEADER,
  },
  contacts_read_tooltip: {
    id: 'PricingSummary.Feature.ContactsReadTooltip',
    defaultMessage: 'Contacts Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  contacts_write_tooltip_heading: {
    id: 'PricingSummary.Feature.ContactsWriteTooltipHeading',
    defaultMessage: 'Contacts Write Heading',
    desc: TYPE_HEADER,
  },
  contacts_write_tooltip: {
    id: 'PricingSummary.Feature.ContactsWriteTooltip',
    defaultMessage: 'Contacts Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  contributor_seats_tooltip_heading: {
    id: 'PricingSummary.Feature.ContributorSeatsTooltipHeading',
    defaultMessage: CONTRIBUTOR_SEATS,
    desc: TYPE_HEADER,
  },
  contributor_seats_tooltip: {
    id: 'PricingSummary.Feature.ContributorSeatsTooltip',
    defaultMessage: CONTRIBUTOR_SEATS_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  create_advanced_features_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateAdvancedFeaturesTooltipHeading',
    defaultMessage: 'A/B test question type',
    desc: TYPE_HEADER,
  },
  create_advanced_features_tooltip: {
    id: 'PricingSummary.Feature.CreateAdvancedFeaturesTooltip',
    defaultMessage:
      'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text.',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_chatbot_avatar_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomChatbotAvatarTooltipHeading',
    defaultMessage: 'Create Custom Chatbot Avatar Heading',
    desc: TYPE_HEADER,
  },
  create_custom_chatbot_avatar_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomChatbotAvatarTooltip',
    defaultMessage: 'Create Custom Chatbot Avatar tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_html_email_message_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomHtmlEmailMessageEnabledTooltipHeading',
    defaultMessage: 'Custom HTML email invitations',
    desc: TYPE_HEADER,
  },
  create_custom_html_email_message_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomHtmlEmailMessageEnabledTooltip',
    defaultMessage:
      'Add custom designs, images, embed videos, or hyperlink text in your email messages used to send your survey.',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_theme_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomThemeEnabledTooltipHeading',
    defaultMessage: 'Custom themes, colors & more',
    desc: TYPE_HEADER,
  },
  create_custom_theme_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomThemeEnabledTooltip',
    defaultMessage:
      'Create custom themes to change the look and feel of your survey. You can edit the colors of different survey elements and choose from several web fonts for your survey.',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_variables_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomVariablesEnabledTooltipHeading',
    defaultMessage: 'Custom variables',
    desc: TYPE_HEADER,
  },
  create_custom_variables_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomVariablesEnabledTooltip',
    defaultMessage:
      'Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.',
    desc: TYPE_PARAGRAPH,
  },
  create_logo_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateLogoEnabledTooltipHeading',
    defaultMessage: 'Customized surveys',
    desc: TYPE_HEADER,
  },
  create_logo_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateLogoEnabledTooltip',
    defaultMessage: `Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey`,
    desc: TYPE_PARAGRAPH,
  },
  create_piping_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreatePipingEnabledTooltipHeading',
    defaultMessage: 'Customized survey experience',
    desc: TYPE_HEADER,
  },
  create_piping_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreatePipingEnabledTooltip',
    defaultMessage: `Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey.`,
    desc: TYPE_PARAGRAPH,
  },
  create_quotas_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateQuotasEnabledTooltipHeading',
    defaultMessage: 'Response quotas',
    desc: TYPE_HEADER,
  },
  create_quotas_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateQuotasEnabledTooltip',
    defaultMessage: 'Close your survey automatically when you get all the qualified responses you need.',
    desc: TYPE_PARAGRAPH,
  },
  create_random_assignment_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateRandomAssignmentEnabledTooltipHeading',
    defaultMessage: 'Create Random Assignment Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_random_assignment_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateRandomAssignmentEnabledTooltip',
    defaultMessage: 'Create Random Assignment Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_randomization_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateRandomizationEnabledTooltipHeading',
    defaultMessage: 'Question & page randomization',
    desc: TYPE_HEADER,
  },
  create_randomization_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateRandomizationEnabledTooltip',
    defaultMessage:
      'Reduce answer bias by randomizing the order of the pages in a survey or the order of questions within a page.',
    desc: TYPE_PARAGRAPH,
  },
  create_skip_logic_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabledTooltipHeading',
    defaultMessage: 'Question and page skip logic',
    desc: TYPE_HEADER,
  },
  create_skip_logic_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabledTooltip',
    defaultMessage: `Create custom paths through surveys that change based on a respondent's answers. Skip logic is also known as 'conditional branching' or 'branch logic'.`,
    desc: TYPE_PARAGRAPH,
  },
  create_templates_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateTemplatesEnabledTooltipHeading',
    defaultMessage: 'Expert, pre-written survey templates',
    desc: TYPE_HEADER,
  },
  create_templates_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateTemplatesEnabledTooltip',
    defaultMessage:
      'Choose from over 180 survey templates in our Question Bank library. All templates are certified by our expert methodologists.',
    desc: TYPE_PARAGRAPH,
  },
  custom_charts_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomChartsTooltipHeading',
    defaultMessage: 'Custom Charts Heading',
    desc: TYPE_HEADER,
  },
  custom_charts_tooltip: {
    id: 'PricingSummary.Feature.CustomChartsTooltip',
    defaultMessage: 'Custom Charts tooltip',
    desc: TYPE_PARAGRAPH,
  },
  custom_question_bank_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomQuestionBankTooltipHeading',
    defaultMessage: 'Custom Question Bank',
    desc: TYPE_HEADER,
  },
  custom_question_bank_tooltip: {
    id: 'PricingSummary.Feature.CustomQuestionBankTooltip',
    defaultMessage:
      'Easily create pre-composed survey questions that are unique to your business, and to share them with your entire organization.',
    desc: TYPE_PARAGRAPH,
  },
  custom_subdomain_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomSubdomainTooltipHeading',
    defaultMessage: 'Custom subdomain',
    desc: TYPE_HEADER,
  },
  custom_subdomain_tooltip: {
    id: 'PricingSummary.Feature.CustomSubdomainTooltip',
    defaultMessage:
      'Get a custom URL and landing page to ensure a seamlessly branded survey experience for your respondents.',
    desc: TYPE_PARAGRAPH,
  },
  custom_templates_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomTemplatesTooltipHeading',
    defaultMessage: 'Shared templates',
    desc: TYPE_HEADER,
  },
  custom_templates_tooltip: {
    id: 'PricingSummary.Feature.CustomTemplatesTooltip',
    defaultMessage: 'Turn your custom surveys into standard templates that everyone in your team can use.',
    desc: TYPE_PARAGRAPH,
  },
  customer_success_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomerSuccessTooltipHeading',
    defaultMessage: 'Customer success',
    desc: TYPE_HEADER,
  },
  customer_success_tooltip: {
    id: 'PricingSummary.Feature.CustomerSuccessTooltip',
    defaultMessage:
      'Get a dedicated customer success manager to help you with onboarding, training users as well as implementing best practices to ensure optimal use of the SurveyMonkey platform across your organization.',
    desc: TYPE_HEADER,
  },
  custom_terms_of_use_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomTermsOfUseTooltipHeading',
    defaultMessage: 'Custom Terms of Use',
    desc: TYPE_HEADER,
  },
  custom_terms_of_use_tooltip: {
    id: 'PricingSummary.Feature.CustomTermsOfUseTooltip',
    defaultMessage: `Ensure your employees opt in to your organization's Terms of Use for SurveyMonkey.`,
    desc: TYPE_PARAGRAPH,
  },
  customer_success_manager_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomerSuccessManagerTooltipHeading',
    defaultMessage: 'Customer Success Manager',
    desc: TYPE_HEADER,
  },
  customer_success_manager_tooltip: {
    id: 'PricingSummary.Feature.CustomerSuccessManagerTooltip',
    defaultMessage:
      'Get a dedicated customer success manager to help you with onboarding, training users as well as implementing best practices to ensure optimal use of the SurveyMonkey platform across your organization.',
    desc: TYPE_PARAGRAPH,
  },
  dashboard_tooltip_heading: {
    id: 'PricingSummary.Feature.DashboardTooltipHeading',
    defaultMessage: 'Dashboard',
    desc: TYPE_HEADER,
  },
  dashboard_tooltip: {
    id: 'PricingSummary.Feature.DashboardTooltip',
    defaultMessage:
      'Tell stories with your data by arranging charts, images, and findings in a custom layout. Share your dashboard with anyone.',
    desc: TYPE_PARAGRAPH,
  },
  data_ownership_tooltip_heading: {
    id: 'PricingSummary.Feature.DataOwnershipTooltipHeading',
    defaultMessage: 'Data Ownership Heading',
    desc: TYPE_HEADER,
  },
  data_ownership_tooltip: {
    id: 'PricingSummary.Feature.DataOwnershipTooltip',
    defaultMessage: 'Data Ownership tooltip',
    desc: TYPE_PARAGRAPH,
  },
  disable_closed_page_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.DisableClosedPageBrandingEnbabledTooltipHeading',
    defaultMessage: 'Disable Closed Page Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  disable_closed_page_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.DisableClosedPageBrandingEnbabledTooltip',
    defaultMessage: 'Disable Closed Page Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  disable_email_message_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.DisableEmailMessageBrandingEnbabledTooltipHeading',
    defaultMessage: 'Disable Email Message Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  disable_email_message_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.DisableEmailMessageBrandingEnbabledTooltip',
    defaultMessage: 'Disable Email Message Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  disable_footer_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.DisableFooterBrandingEnbabledTooltipHeading',
    defaultMessage: 'Disable Footer Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  disable_footer_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.DisableFooterBrandingEnbabledTooltip',
    defaultMessage: 'Disable Footer Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  download_as_csv_xls_pdf_tooltip_heading: {
    id: 'PricingSummary.Feature.DownloadAsCsvXlsPdfTooltipHeading',
    defaultMessage: 'Download as Csv/Xls/Pdf Heading',
    desc: TYPE_HEADER,
  },
  download_as_csv_xls_pdf_tooltip: {
    id: 'PricingSummary.Feature.DownloadAsCsvXlsPdfTooltip',
    defaultMessage: 'Download as Csv/Xls/Pdf tooltip',
    desc: TYPE_PARAGRAPH,
  },
  email_support_tooltip_heading: {
    id: 'PricingSummary.Feature.EmailSupportTooltipHeading',
    defaultMessage: SUPPORT,
    desc: TYPE_HEADER,
  },
  email_support_tooltip: {
    id: 'PricingSummary.Feature.EmailSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  email_tracking_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.EmailTrackingEnabledTooltipHeading',
    defaultMessage: 'Email Tracking Enabled Heading',
    desc: TYPE_HEADER,
  },
  email_tracking_enabled_tooltip: {
    id: 'PricingSummary.Feature.EmailTrackingEnabledTooltip',
    defaultMessage: 'Email Tracking Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  enhanced_governance_tooltip_heading: {
    id: 'PricingSummary.Feature.EnhancedGovernanceTooltipHeading',
    defaultMessage: 'Governance and security',
    desc: TYPE_HEADER,
  },
  enhanced_governance_tooltip: {
    id: 'PricingSummary.Feature.EnhancedGovernanceTooltip',
    defaultMessage:
      'Get access to a vast array of governance and security features, including SSO for user authentication, data encryption, access controls, SSAE-16 SOC II compliant data centers and more.',
    desc: TYPE_PARAGRAPH,
  },
  essential_question_types_tooltip_heading: {
    id: 'PricingSummary.Feature.EssentialQuestionTypesTooltipHeading',
    defaultMessage: 'Essential question types',
    desc: TYPE_HEADER,
  },
  essential_question_types_tooltip: {
    id: 'PricingSummary.Feature.EssentialQuestionTypesTooltip',
    defaultMessage: 'Use essential questions such as multiple choice, checkboxes, dropdown, and text box.',
    desc: TYPE_PARAGRAPH,
  },
  extended_piping_tooltip_heading: {
    id: 'PricingSummary.Feature.ExtendedPipingTooltipHeading',
    defaultMessage: ADVANCED_LOGIC,
    desc: TYPE_HEADER,
  },
  extended_piping_tooltip: {
    id: 'PricingSummary.Feature.ExtendedPipingTooltip',
    defaultMessage: ADVANCED_LOGIC_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  extract_data_tooltip_heading: {
    id: 'PricingSummary.Feature.ExtractDataTooltipHeading',
    defaultMessage: 'Extract data',
    desc: TYPE_HEADER,
  },
  extract_data_tooltip: {
    id: 'PricingSummary.Feature.ExtractDataTooltip',
    defaultMessage: 'Extract and leverage your survey data using powerful 3rd-party integration tools.',
    desc: TYPE_PARAGRAPH,
  },
  file_upload_tooltip_heading: {
    id: 'PricingSummary.Feature.FileUploadTooltipHeading',
    defaultMessage: 'File upload',
    desc: TYPE_HEADER,
  },
  file_upload_tooltip: {
    id: 'PricingSummary.Feature.FileUploadTooltip',
    defaultMessage:
      'Allow respondents to upload a file as part of their survey response. You can add up to 20 file upload questions per survey.',
    desc: TYPE_PARAGRAPH,
  },
  filter_crosstab_tooltip_heading: {
    id: 'PricingSummary.Feature.FilterCrosstabTooltipHeading',
    defaultMessage: 'Filter Crosstab Heading',
    desc: TYPE_HEADER,
  },
  filter_crosstab_tooltip: {
    id: 'PricingSummary.Feature.FilterCrosstabTooltip',
    defaultMessage: 'Filter Crosstab tooltip',
    desc: TYPE_PARAGRAPH,
  },
  flexible_plan_types_tooltip_heading: {
    id: 'PricingSummary.FlexiblePlanTypesTooltipHeading',
    defaultMessage: 'Flexible plan types',
    desc: TYPE_HEADER,
  },
  flexible_plan_types_tooltip: {
    id: 'PricingSummary.FlexiblePlanTypesTooltip',
    defaultMessage: `Enjoy flexible and custom plan types to fit your organization's survey needs.`,
    desc: TYPE_PARAGRAPH,
  },
  footer_branding_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanExportHideBrandingTooltipHeading',
    defaultMessage: 'Remove footer',
    desc: TYPE_HEADER,
  },
  footer_branding_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanExportHideBrandingTooltip',
    defaultMessage:
      'Turn off the "powered by SurveyMonkey" footer that appears by default in your survey design, email invitation messages, and embedded surveys.',
    desc: TYPE_PARAGRAPH,
  },
  funneling_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.FunnelingEnabledTooltipHeading',
    defaultMessage: 'Funneling Enabled Heading',
    desc: TYPE_HEADER,
  },
  funneling_enabled_tooltip: {
    id: 'PricingSummary.Feature.FunnelingEnabledTooltip',
    defaultMessage: 'Funneling Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  gather_comments_tooltip_heading: {
    id: 'PricingSummary.Feature.GateherCommentsTooltipHeading',
    defaultMessage: 'Commenting feature',
    desc: TYPE_HEADER,
  },
  gather_comments_tooltip: {
    id: 'PricingSummary.Feature.GateherCommentsTooltip',
    defaultMessage:
      'Invite people to provide feedback on your survey projects all in one place. Our commenting feature allows you to share both survey drafts and results with anyone you want.',
    desc: TYPE_HEADER,
  },
  global_settings_tooltip_heading: {
    id: 'PricingSummary.Feature.GlobalSettingsTooltipHeading',
    defaultMessage: 'Global settings',
    desc: TYPE_HEADER,
  },
  global_settings_tooltip: {
    id: 'PricingSummary.Feature.GlobalSettingsTooltip',
    defaultMessage:
      'Create global settings for everyone in your plan. Includes PII management, collector and respondent data settings, and Audience credits management.',
    desc: TYPE_PARAGRAPH,
  },
  gold_features_included_tooltip_heading: {
    id: 'PricingSummary.Feature.GoldFeaturesIncludedTooltipHeading',
    defaultMessage: 'Gold Features Included Heading',
    desc: TYPE_HEADER,
  },
  gold_features_included_tooltip: {
    id: 'PricingSummary.Feature.GoldFeaturesIncludedTooltip',
    defaultMessage: 'Gold Features Included tooltip',
    desc: TYPE_PARAGRAPH,
  },
  group_contacts_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupContactsLimitTooltipHeading',
    defaultMessage: 'Group Contacts Limit Heading',
    desc: TYPE_HEADER,
  },
  group_contacts_limit_tooltip: {
    id: 'PricingSummary.Feature.GroupContactsLimitTooltip',
    defaultMessage: 'Group Contacts Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  group_templates_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupTemplatesTooltipHeading',
    defaultMessage: 'Group Templates Heading',
    desc: TYPE_HEADER,
  },
  group_templates_tooltip: {
    id: 'PricingSummary.Feature.GroupTemplatesTooltip',
    defaultMessage: 'Group Templates tooltip',
    desc: TYPE_PARAGRAPH,
  },
  groups_read_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupsReadTooltipHeading',
    defaultMessage: 'Groups Read Heading',
    desc: TYPE_HEADER,
  },
  groups_read_tooltip: {
    id: 'PricingSummary.Feature.GroupsReadTooltip',
    defaultMessage: 'Groups Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  groups_write_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupsWriteTooltipHeading',
    defaultMessage: 'Groups Write Heading',
    desc: TYPE_HEADER,
  },
  groups_write_tooltip: {
    id: 'PricingSummary.Feature.GroupsWriteTooltip',
    defaultMessage: 'Groups Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  hide_export_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.HideExportBrandingEnabledTooltipHeading',
    defaultMessage: 'Hide Export Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  hide_export_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.HideExportBrandingEnabledTooltip',
    defaultMessage: 'Hide Export Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  hipaa_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.HipaaEnabledTooltipHeading',
    defaultMessage: 'Hipaa-compliant features',
    desc: TYPE_HEADER,
  },
  hipaa_enabled_tooltip: {
    id: 'PricingSummary.Feature.HipaaEnabledTooltip',
    defaultMessage:
      'Collect and manage Protected Health Information (PHI) through surveys. To enable HIPAA features, you must enter into a Business Associate Agreement (BAA) with SurveyMonkey.',
    desc: TYPE_PARAGRAPH,
  },
  integrations_tooltip_heading: {
    id: 'PricingSummary.Feature.IntegrationsTooltipHeading',
    defaultMessage: 'Integrations',
    desc: TYPE_HEADER,
  },
  integrations_tooltip: {
    id: 'PricingSummary.Feature.IntegrationsTooltip',
    defaultMessage:
      'Integrate your survey data into important business applications that your organization already uses such as Salesforce, Marketo, Oracle Eloqua, and Tableau.',
    desc: TYPE_PARAGRAPH,
  },
  enterprise_only_integrations_tooltip_heading: {
    id: 'PricingSummary.Feature.EnterpriseOnlyIntegrationsTooltipHeading',
    defaultMessage: 'Enterprise-only integrations',
    desc: TYPE_HEADER,
  },
  enterprise_only_integrations_tooltip: {
    id: 'PricingSummary.Feature.EnterpriseOnlyIntegrationsTooltip',
    defaultMessage:
      'Enterprise plans enjoy unlimited API access and can add on integrations with Salesforce, Marketo, Eloqua, Tableau, and more.',
    desc: TYPE_PARAGRAPH,
  },
  kiosk_mode_inactivity_timer_tooltip_heading: {
    id: 'PricingSummary.Feature.KioskModeInactivityTimerTooltipHeading',
    defaultMessage: 'Kiosk Mode: Inactivity Timer',
    desc: TYPE_HEADER,
  },
  kiosk_mode_inactivity_timer_tooltip: {
    id: 'PricingSummary.Feature.KioskModeInactivityTimerTooltip',
    defaultMessage: `When a survey's inactive for the amount of time you choose, it will loop back to start for the next person. Available in the SurveyMonkey Anywhere app.`,
    desc: TYPE_PARAGRAPH,
  },
  kiosk_mode_passcode_lock_tooltip_heading: {
    id: 'PricingSummary.Feature.KioskModePasscodeLockTooltipHeading',
    defaultMessage: 'Kiosk Mode: Passcode Lock',
    desc: TYPE_HEADER,
  },
  kiosk_mode_passcode_lock_tooltip: {
    id: 'PricingSummary.Feature.KioskModePasscodeLockTooltip',
    defaultMessage:
      'Keep your device secure-set a passcode that must be entered to exit the survey. Available in the SurveyMonkey Anywhere app.',
    desc: TYPE_PARAGRAPH,
  },
  labeling_titles_numbering_tooltip_heading: {
    id: 'PricingSummary.Feature.LabelingTitlesNumberingTooltipHeading',
    defaultMessage: 'Labeling, titles & numbering',
    desc: TYPE_HEADER,
  },
  labeling_titles_numbering_tooltip: {
    id: 'PricingSummary.Feature.LabelingTitlesNumberingTooltip',
    defaultMessage:
      'Guide respondents through your surveys with labels, titles, and page numbers for any page in your surveys.',
    desc: TYPE_PARAGRAPH,
  },
  library_read_tooltip_heading: {
    id: 'PricingSummary.Feature.LibraryReadTooltipHeading',
    defaultMessage: 'Library Read Heading',
    desc: TYPE_HEADER,
  },
  library_read_tooltip: {
    id: 'PricingSummary.Feature.LibraryReadTooltip',
    defaultMessage: 'Library Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  lite_library_tooltip_heading: {
    id: 'PricingSummary.Feature.LiteLibraryTooltipHeading',
    defaultMessage: 'Lite Library Heading',
    desc: TYPE_HEADER,
  },
  lite_library_tooltip: {
    id: 'PricingSummary.Feature.LiteLibraryTooltip',
    defaultMessage: 'Lite Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  max_collectors_per_survey_tooltip_heading: {
    id: 'PricingSummary.Feature.MaxCollectorsPerSurveyTooltipHeading',
    defaultMessage: 'Max Collectors Per Survey Heading',
    desc: TYPE_HEADER,
  },
  max_collectors_per_survey_tooltip: {
    id: 'PricingSummary.Feature.MaxCollectorsPerSurveyTooltip',
    defaultMessage: 'Max Collectors Per Survey tooltip',
    desc: TYPE_PARAGRAPH,
  },
  maximum_daily_messages_tooltip_heading: {
    id: 'PricingSummary.Feature.MaximumDailyMessagesTooltipHeading',
    defaultMessage: 'Maximum Daily Message Heading',
    desc: TYPE_HEADER,
  },
  maximum_daily_messages_tooltip: {
    id: 'PricingSummary.Feature.MaximumDailyMessagesTooltip',
    defaultMessage: 'Maximum Daily Message tooltip',
    desc: TYPE_PARAGRAPH,
  },
  menu_matrix_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.MenuMatrixEnabledTooltipHeading',
    defaultMessage: 'Matrix of dropdown menus',
    desc: TYPE_HEADER,
  },
  menu_matrix_enabled_tooltip: {
    id: 'PricingSummary.Feature.MenuMatrixEnabledTooltip',
    defaultMessage:
      'Allow respondents to evaluate several items using the same set of measurements by choosing from a preset list of answer choices.',
    desc: TYPE_PARAGRAPH,
  },
  metadata_settings_tooltip_heading: {
    id: 'PricingSummary.Feature.MetadataSettingsTooltipHeading',
    defaultMessage: 'Metadata Settings Heading',
    desc: TYPE_HEADER,
  },
  metadata_settings_tooltip: {
    id: 'PricingSummary.Feature.MetadataSettingsTooltip',
    defaultMessage: 'Metadata Settings tooltip',
    desc: TYPE_PARAGRAPH,
  },
  mobile_apps_ios_android_tooltip_heading: {
    id: 'PricingSummary.Feature.MobileIosAndroidAppsTooltipHeading',
    defaultMessage: 'Mobile apps for iOS and Android',
    desc: TYPE_HEADER,
  },
  mobile_apps_ios_android_tooltip: {
    id: 'PricingSummary.Feature.MobileIosAndroidAppsTooltip',
    defaultMessage:
      'Access the essential features you need to create a survey, collect responses, and analyze results with the free SurveyMonkey app for iOS and Android.',
    desc: TYPE_PARAGRAPH,
  },
  mobile_sdk_pull_response_data_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.MobileSdkPullResponseDataEnabledTooltipHeading',
    defaultMessage: 'Mobile SDK - Data Pull',
    desc: TYPE_HEADER,
  },
  mobile_sdk_pull_response_data_enabled_tooltip: {
    id: 'PricingSummary.Feature.MobileSdkPullResponseDataEnabledTooltip',
    defaultMessage:
      'Take actions in your app based on survey responses collected through the Mobile SDK. For example, prompt people to leave a review if they enter a positive rating.',
    desc: TYPE_PARAGRAPH,
  },
  mta_sparkpost_low_risk_ip_pools_tooltip_heading: {
    id: 'PricingSummary.Feature.MtaSparkpostLowRiskIpPoolsTooltipHeading',
    defaultMessage: 'MTA Sparkpost Low Risk Ip Pools Heading',
    desc: TYPE_HEADER,
  },
  mta_sparkpost_low_risk_ip_pools_tooltip: {
    id: 'PricingSummary.Feature.MtaSparkpostLowRiskIpPoolsTooltip',
    defaultMessage: 'MTA Sparkpost Low Risk Ip Pools tooltip',
    desc: TYPE_PARAGRAPH,
  },
  multilingual_tooltip_heading: {
    id: 'PricingSummary.Feature.MultilingualTooltipHeading',
    defaultMessage: 'Multilingual surveys',
    desc: TYPE_HEADER,
  },
  multilingual_tooltip: {
    id: 'PricingSummary.Feature.MultilingualTooltip',
    defaultMessage: `Reach everyone in the language they're most comfortable with. Add multiple languages to a single survey, and analyze all your results together as one data set.`,
    desc: TYPE_PARAGRAPH,
  },
  multiple_block_rotation_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.MultipleBlockRotationEnabledTooltipHeading',
    defaultMessage: 'Block randomization',
    desc: TYPE_HEADER,
  },
  multiple_block_rotation_enabled_tooltip: {
    id: 'PricingSummary.Feature.MultipleBlockRotationEnabledTooltip',
    defaultMessage:
      'Blocks are groups of pages, where each group contains related questions about a particular concept you want to test. You can use block randomization logic to rotate, flip, or randomize blocks to minimize order bias.',
    desc: TYPE_PARAGRAPH,
  },
  multiple_users_tooltip_heading: {
    id: 'PricingSummary.Feature.MultipleUsersTooltipHeading',
    defaultMessage: 'Multiple Users Heading',
    desc: TYPE_HEADER,
  },
  multiple_users_tooltip: {
    id: 'PricingSummary.Feature.MultipleUsersTooltip',
    defaultMessage: 'Multiple Users tooltip',
    desc: TYPE_PARAGRAPH,
  },
  new_stock_themes_tooltip_heading: {
    id: 'PricingSummary.Feature.NewStockThemesTooltipHeading',
    defaultMessage: 'New Stock Themes Heading',
    desc: TYPE_HEADER,
  },
  new_stock_themes_tooltip: {
    id: 'PricingSummary.Feature.NewStockThemesTooltip',
    defaultMessage: 'New Stock Themes tooltip',
    desc: TYPE_PARAGRAPH,
  },
  notification_center_tooltip_heading: {
    id: 'PricingSummary.Feature.NotificationCenterTooltipHeading',
    defaultMessage: 'Notification Center Heading',
    desc: TYPE_HEADER,
  },
  notification_center_tooltip: {
    id: 'PricingSummary.Feature.NotificationCenterTooltip',
    defaultMessage: 'Notification Center tooltip',
    desc: TYPE_PARAGRAPH,
  },
  num_free_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.NumFreeResponsesTooltipHeading',
    defaultMessage: NUM_RESPONSES,
    desc: TYPE_HEADER,
  },
  num_free_responses_tooltip: {
    id: 'PricingSummary.Feature.NumFreeResponsesTooltip',
    defaultMessage: NUM_RESPONSES_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  paid_to_group_rollout_tooltip_heading: {
    id: 'PricingSummary.Feature.PaidToGroupRolloutTooltipHeading',
    defaultMessage: 'Paid To Group Rollout Heading',
    desc: TYPE_HEADER,
  },
  paid_to_group_rollout_tooltip: {
    id: 'PricingSummary.Feature.PaidToGroupRolloutTooltip',
    defaultMessage: 'Paid To Group Rollout tooltip',
    desc: TYPE_PARAGRAPH,
  },
  papi_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.PapiEnabledTooltipHeading',
    defaultMessage: 'Papi Enabled Heading',
    desc: TYPE_HEADER,
  },
  papi_enabled_tooltip: {
    id: 'PricingSummary.Feature.PapiEnabledTooltip',
    defaultMessage: 'Papi Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  payment_qt_tooltip_heading: {
    id: 'PricingSummary.Feature.PaymentQTTooltipHeading',
    defaultMessage: 'Accept payments',
    desc: TYPE_HEADER,
  },
  payment_qt_tooltip: {
    id: 'PricingSummary.Feature.PaymentQTTooltip',
    defaultMessage: 'Accept credit card payments from respondents in your surveys with our Stripe integration.',
    desc: TYPE_PARAGRAPH,
  },
  phone_support_tooltip_heading: {
    id: 'PricingSummary.Feature.PhoneSupportTooltipHeading',
    defaultMessage: SUPPORT,
    desc: TYPE_HEADER,
  },
  phone_support_tooltip: {
    id: 'PricingSummary.Feature.PhoneSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  benchmark_logic_tooltip_heading: {
    id: 'PricingSummary.Feature.PlansBenchmarkTooltipHeading',
    defaultMessage: 'SurveyMonkey industry benchmarks',
    desc: TYPE_HEADER,
  },
  benchmark_logic_tooltip: {
    id: 'PricingSummary.Feature.PlansBenchmarkTooltip',
    defaultMessage: `Compare your results against the Industry Benchmark to understand how you're doing in the context of your greater industry. See your results in context to see how you measure up against your peers.`,
    desc: TYPE_PARAGRAPH,
  },
  plans_benchmarks_tooltip_heading: {
    id: 'PricingSummary.Feature.PlansBenchmarksTooltipHeading',
    defaultMessage: 'SurveyMonkey Global Benchmarks',
    desc: TYPE_HEADER,
  },
  plans_benchmarks_tooltip: {
    id: 'PricingSummary.Feature.PlansBenchmarksTooltip',
    defaultMessage:
      'SurveyMonkey Global Benchmarks give your results context by letting you compare them with the global average. More specific comparison data is available for an extra fee.',
    desc: TYPE_PARAGRAPH,
  },
  premium_themes_tooltip_heading: {
    id: 'PricingSummary.Feature.PremiumThemesTooltipHeading',
    defaultMessage: 'Premium themes',
    desc: TYPE_HEADER,
  },
  premium_themes_tooltip: {
    id: 'PricingSummary.Feature.PremiumThemesTooltip',
    defaultMessage:
      'Select from pre-designed themes to pick a survey theme that matches the topic of your survey. You can also edit the premium themes to create a fully customized design using colors, fonts, images and layouts.',
    desc: TYPE_PARAGRAPH,
  },
  priority_email_support_tooltip_heading: {
    id: 'PricingSummary.Feature.PrimaryEmailSupportTooltipHeading',
    defaultMessage: SUPPORT,
    desc: TYPE_HEADER,
  },
  priority_email_support_tooltip: {
    id: 'PricingSummary.Feature.PrimaryEmailSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  private_apps_tooltip_heading: {
    id: 'PricingSummary.Feature.PrivateAppsTooltipHeading',
    defaultMessage: 'Unlimited API access',
    desc: TYPE_HEADER,
  },
  private_apps_tooltip: {
    id: 'PricingSummary.Feature.PrivateAppsTooltip',
    defaultMessage:
      'Get unlimited access to the SurveyMonkey API to integrate survey data into your mobile and web applications.',
    desc: TYPE_PARAGRAPH,
  },
  question_library_tooltip_heading: {
    id: 'PricingSummary.Feature.QuestionLibraryTooltipHeading',
    defaultMessage: 'Question Bank approved questions',
    desc: TYPE_HEADER,
  },
  question_library_tooltip: {
    id: 'PricingSummary.Feature.QuestionLibraryTooltip',
    defaultMessage:
      'Rely on over 1800 pre-written survey questions (and 180+ survey templates), written by experts to make it easier to get great results.',
    desc: TYPE_PARAGRAPH,
  },
  question_library_intl_tooltip_heading: {
    id: 'PricingSummary.Feature.QuestionLibraryIntlTooltipHeading',
    defaultMessage: 'Question Library Intl Heading',
    desc: TYPE_HEADER,
  },
  question_library_intl_tooltip: {
    id: 'PricingSummary.Feature.QuestionLibraryIntlTooltip',
    defaultMessage: 'Question Library Intl tooltip',
    desc: TYPE_PARAGRAPH,
  },
  quizzes_pro_tooltip_heading: {
    id: 'PricingSummary.Feature.QuizzesProTooltipHeading',
    defaultMessage: 'Quizzes',
    desc: TYPE_HEADER,
  },
  quizzes_pro_tooltip: {
    id: 'PricingSummary.Feature.QuizzesProTooltip',
    defaultMessage: `Easily create tests and assessments with automatic scoring for employees, customers, students, and more. You can choose whether you want to display your respondent's score to them after they complete your quiz. You'll also be able to see rankings, segment response data, and access statistics for your results.`,
    desc: TYPE_PARAGRAPH,
  },
  randomize_answer_choices_tooltip_heading: {
    id: 'PricingSummary.Feature.RandomizeAnswerChoicesTooltipHeading',
    defaultMessage: 'Randomize Answer Choices Heading',
    desc: TYPE_HEADER,
  },
  randomize_answer_choices_tooltip: {
    id: 'PricingSummary.Feature.RandomizeAnswerChoicesTooltip',
    defaultMessage: 'Reduce bias by randomly changing the order of answer choices for different respondents.',
    desc: TYPE_PARAGRAPH,
  },
  receive_transferred_survey_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.ReceiveTransferredSurveyEnabledTooltipHeading',
    defaultMessage: 'Receive Transferred Survey Enabled Heading',
    desc: TYPE_HEADER,
  },
  receive_transferred_survey_enabled_tooltip: {
    id: 'PricingSummary.Feature.ReceiveTransferredSurveyEnabledTooltip',
    defaultMessage: 'Receive Transferred Survey Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  record_respondent_email_address_tooltip_heading: {
    id: 'PricingSummary.Feature.RecordRespondentEmailAddressTooltipHeading',
    defaultMessage: 'Record respondent email address',
    desc: TYPE_HEADER,
  },
  record_respondent_email_address_tooltip: {
    id: 'PricingSummary.Feature.RecordRespondentEmailAddressTooltip',
    defaultMessage:
      'Automatically record the email address of respondents to track who takes your surveys, or to follow up with them later.',
    desc: TYPE_PARAGRAPH,
  },
  recurring_email_collector_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.RecurringEmailCollectorEnabledTooltipHeading',
    defaultMessage: 'Recurring Email Collector Enabled Heading',
    desc: TYPE_HEADER,
  },
  recurring_email_collector_enabled_tooltip: {
    id: 'PricingSummary.Feature.RecurringEmailCollectorEnabledTooltip',
    defaultMessage: 'Recurring Email Collector Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  recurring_surveys_tooltip_heading: {
    id: 'PricingSummary.Feature.RecurringSurveysTooltipHeading',
    defaultMessage: 'Recurring surveys',
    desc: TYPE_HEADER,
  },
  recurring_surveys_tooltip: {
    id: 'PricingSummary.Feature.RecurringSurveysTooltip',
    defaultMessage: `Recurring surveys make it easy to collect new results for the same survey on a weekly, monthly, or quarterly basis. We'll email you new survey links when they're ready, so all you need to do is copy each new link and send it to respondents. Filter your results by each occurrence to see how people responded differently over time.`,
    desc: TYPE_PARAGRAPH,
  },
  reshare_tooltip_heading: {
    id: 'PricingSummary.Feature.ReshareTooltipHeading',
    defaultMessage: 'Reshare Heading',
    desc: TYPE_HEADER,
  },
  reshare_tooltip: {
    id: 'PricingSummary.Feature.ReshareTooltip',
    defaultMessage: 'Reshare tooltip',
    desc: TYPE_PARAGRAPH,
  },
  respondent_receipt_tooltip_heading: {
    id: 'PricingSummary.Feature.RespondentReceiptTooltipHeading',
    defaultMessage: 'Confirmation Email to Respondents',
    desc: TYPE_HEADER,
  },
  respondent_receipt_tooltip: {
    id: 'PricingSummary.Feature.RespondentReceiptTooltip',
    defaultMessage:
      'When distributing surveys with the email collector, send a confirmation email to each respondent with a copy of their answers.',
    desc: TYPE_PARAGRAPH,
  },
  response_alerts_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponseAlertsTooltipHeading',
    defaultMessage: 'Response alerts',
    desc: TYPE_HEADER,
  },
  response_alerts_tooltip: {
    id: 'PricingSummary.Feature.ResponseAlertsTooltip',
    defaultMessage: `Receive email notifications about new survey responses. You can share Response Alerts with other people (in or outside your team)-as long as you're the survey owner.`,
    desc: TYPE_PARAGRAPH,
  },
  response_quality_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponseQualityEnabledTooltipHeading',
    defaultMessage: 'Response quality',
    desc: TYPE_HEADER,
  },
  response_quality_enabled_tooltip: {
    id: 'PricingSummary.Feature.ResponseQualityEnabledTooltip',
    defaultMessage:
      'Response Quality uses machine learning to scan your survey results and flag poor-quality responses.',
    desc: TYPE_PARAGRAPH,
  },
  responses_read_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponsesReadTooltipHeading',
    defaultMessage: 'Responses Read Heading',
    desc: TYPE_HEADER,
  },
  responses_read_tooltip: {
    id: 'PricingSummary.Feature.ResponsesReadTooltip',
    defaultMessage: 'Responses Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  responses_read_detail_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponsesReadDetailTooltipHeading',
    defaultMessage: 'Responses Read Detail Heading',
    desc: TYPE_HEADER,
  },
  responses_read_detail_tooltip: {
    id: 'PricingSummary.Feature.ResponsesReadDetailTooltip',
    defaultMessage: 'Responses Read Detail tooltip',
    desc: TYPE_PARAGRAPH,
  },
  responses_write_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponsesWriteTooltipHeading',
    defaultMessage: 'Responses Write Heading',
    desc: TYPE_HEADER,
  },
  responses_write_tooltip: {
    id: 'PricingSummary.Feature.ResponsesWriteTooltip',
    defaultMessage: 'Responses Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  roles_read_tooltip_heading: {
    id: 'PricingSummary.Feature.RolesReadTooltipHeading',
    defaultMessage: 'Roles Read Heading',
    desc: TYPE_HEADER,
  },
  roles_read_tooltip: {
    id: 'PricingSummary.Feature.RolesReadTooltip',
    defaultMessage: 'Roles Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  roles_write_tooltip_heading: {
    id: 'PricingSummary.Feature.RolesWriteTooltipHeading',
    defaultMessage: 'Roles Write Heading',
    desc: TYPE_HEADER,
  },
  roles_write_tooltip: {
    id: 'PricingSummary.Feature.RolesWriteTooltip',
    defaultMessage: 'Roles Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  sa_en_ga_tooltip_heading: {
    id: 'PricingSummary.Feature.SaEnGaTooltipHeading',
    defaultMessage: 'SA EN GA Heading',
    desc: TYPE_HEADER,
  },
  sa_en_ga_tooltip: {
    id: 'PricingSummary.Feature.SaEnGaTooltip',
    defaultMessage: 'SA EN GA tooltip',
    desc: TYPE_PARAGRAPH,
  },
  select_features_included_tooltip_heading: {
    id: 'PricingSummary.Feature.SelectFeaturesIncludedTooltipHeading',
    defaultMessage: 'Select Features Included Heading',
    desc: TYPE_HEADER,
  },
  select_features_included_tooltip: {
    id: 'PricingSummary.Feature.SelectFeaturesIncludedTooltip',
    defaultMessage: 'Select Features Included tooltip',
    desc: TYPE_PARAGRAPH,
  },
  send_surveys_tooltip_heading: {
    id: 'PricingSummary.Feature.SendSurveysTooltipHeading',
    defaultMessage: 'Send surveys',
    desc: TYPE_HEADER,
  },
  send_surveys_tooltip: {
    id: 'PricingSummary.Feature.SendSurveysTooltip',
    defaultMessage: 'Seamlessly send surveys using powerful 3rd-party integration tools.',
    desc: TYPE_PARAGRAPH,
  },
  share_surveys_tooltip_heading: {
    id: 'PricingSummary.Feature.ShareSurveysTooltipHeading',
    defaultMessage: 'Share survey data',
    desc: TYPE_HEADER,
  },
  share_surveys_tooltip: {
    id: 'PricingSummary.Feature.ShareSurveysTooltip',
    defaultMessage: 'Invite anyone to view data from your survey.',
    desc: TYPE_PARAGRAPH,
  },
  share_with_your_organization_tooltip_heading: {
    id: 'PricingSummary.Feature.ShareWithYourOrganizationTooltipHeading',
    defaultMessage: 'Share With Your Organization Heading',
    desc: TYPE_HEADER,
  },
  share_with_your_organization_tooltip: {
    id: 'PricingSummary.Feature.ShareWithYourOrganizationTooltip',
    defaultMessage: 'Share With Your Organization tooltip',
    desc: TYPE_PARAGRAPH,
  },
  shared_assets_tooltip_heading: {
    id: 'PricingSummary.Feature.SharedGroupLibraryTooltipHeading',
    defaultMessage: 'Shared library',
    desc: TYPE_HEADER,
  },
  shared_assets_tooltip: {
    id: 'PricingSummary.Feature.SharedGroupLibraryTooltip',
    defaultMessage: 'Get access to shared images, documents, themes, and templates that everyone in your team can use.',
    desc: TYPE_PARAGRAPH,
  },
  shared_group_library_tooltip_heading: {
    id: 'PricingSummary.Feature.SharedGroupLibraryTooltipHeading',
    defaultMessage: 'Shared Group Library Heading',
    desc: TYPE_HEADER,
  },
  shared_group_library_tooltip: {
    id: 'PricingSummary.Feature.SharedGroupLibraryTooltip',
    defaultMessage: 'Shared Group Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  shared_library_tooltip_heading: {
    id: 'PricingSummary.Feature.SharedLibraryTooltipHeading',
    defaultMessage: 'Shared library',
    desc: TYPE_HEADER,
  },
  shared_library_tooltip: {
    id: 'PricingSummary.Feature.SharedLibraryTooltip',
    defaultMessage: 'Get access to shared images, documents, themes, and templates that everyone in your team can use.',
    desc: TYPE_PARAGRAPH,
  },
  show_create_crosstab_tooltip_heading: {
    id: 'PricingSummary.Feature.ShowCreateCrosstabTooltipHeading',
    defaultMessage: 'Crosstabs',
    desc: TYPE_HEADER,
  },
  show_create_crosstab_tooltip: {
    id: 'PricingSummary.Feature.ShowCreateCrosstabTooltip',
    defaultMessage:
      'Run advanced comparisons across multiple questions, uncover statistically significant differences, and share your crosstab report with anyone.',
    desc: TYPE_PARAGRAPH,
  },
  show_create_header_upgrade_button_tooltip_heading: {
    id: 'PricingSummary.Feature.ShowCreateHeaderUpgradeButtonTooltipHeading',
    defaultMessage: 'Show Create Header Upgrade Button Heading',
    desc: TYPE_HEADER,
  },
  show_create_header_upgrade_button_tooltip: {
    id: 'PricingSummary.Feature.ShowCreateHeaderUpgradeButtonTooltip',
    defaultMessage: 'Show Create Header Upgrade Button tooltip',
    desc: TYPE_PARAGRAPH,
  },
  show_sig_diffs_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.ShowSigDiffsEnabledTooltipHeading',
    defaultMessage: 'Statistical significance',
    desc: TYPE_HEADER,
  },
  show_sig_diffs_enabled_tooltip: {
    id: 'PricingSummary.Feature.ShowSigDiffsEnabledTooltip',
    defaultMessage: 'Use to see if there are statistically significant differences between response groups.',
    desc: TYPE_PARAGRAPH,
  },
  single_sign_on_tooltip_heading: {
    id: 'PricingSummary.Feature.SingleSignOnTooltipHeading',
    defaultMessage: 'Single sign-on',
    desc: TYPE_HEADER,
  },
  single_sign_on_tooltip: {
    id: 'PricingSummary.Feature.SingleSignOnTooltip',
    defaultMessage:
      'Control access to SurveyMonkey across the organization and define authentication policies for increased security and governance.',
    desc: TYPE_PARAGRAPH,
  },
  skip_logic_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabledTooltipHeading',
    defaultMessage: 'Customized survey experience',
    desc: TYPE_HEADER,
  },
  skip_logic_tooltip: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabledTooltip',
    defaultMessage: `Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey.`,
    desc: TYPE_PARAGRAPH,
  },
  smart_notifications_tooltip_heading: {
    id: 'PricingSummary.Feature.SmartNotificationsTooltipHeading',
    defaultMessage: 'Smart Notifications Heading',
    desc: TYPE_HEADER,
  },
  smart_notifications_tooltip: {
    id: 'PricingSummary.Feature.SmartNotificationsTooltip',
    defaultMessage: 'Smart Notifications tooltip',
    desc: TYPE_PARAGRAPH,
  },
  ssl_tls_encryption_tooltip_heading: {
    id: 'PricingSummary.Feature.SslTlsEncryptionTooltipHeading',
    defaultMessage: 'SSL/TLS Encryption Heading',
    desc: TYPE_HEADER,
  },
  ssl_tls_encryption_tooltip: {
    id: 'PricingSummary.Feature.SslTlsEncryptionTooltip',
    defaultMessage: 'SSL/TLS Encryption tooltip',
    desc: TYPE_PARAGRAPH,
  },
  star_rating_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.StarRatingQuestionTypeTooltipHeading',
    defaultMessage: 'Star Rating Question Type Heading',
    desc: TYPE_HEADER,
  },
  star_rating_question_type_tooltip: {
    id: 'PricingSummary.Feature.StarRatingQuestionTypeTooltip',
    defaultMessage: 'Star Rating Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  statistical_significance_tooltip_heading: {
    id: 'PricingSummary.Feature.StatisticalSignifcanceTooltipHeading',
    defaultMessage: 'Advanced survey analysis',
    desc: TYPE_HEADER,
  },
  statistical_significance_tooltip: {
    id: 'PricingSummary.Feature.StatisticalSignifcanceTooltip',
    defaultMessage:
      'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: TYPE_PARAGRAPH,
  },
  survey_branding_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveyBrandingTooltipHeading',
    defaultMessage: 'Customized surveys',
    desc: TYPE_HEADER,
  },
  survey_branding_tooltip: {
    id: 'PricingSummary.Feature.SurveyBrandingTooltip',
    defaultMessage: `Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey`,
    desc: TYPE_PARAGRAPH,
  },
  survey_create_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveyCreateLimitTooltipHeading',
    defaultMessage: 'Number of surveys',
    desc: TYPE_HEADER,
  },
  survey_create_limit_tooltip: {
    id: 'PricingSummary.Feature.SurveyCreateLimitTooltip',
    defaultMessage: 'You can create and send as many surveys, polls, and quizzes as you need with any plan.',
    desc: TYPE_PARAGRAPH,
  },
  survey_templates_intl_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveyTemplatesIntlTooltipHeading',
    defaultMessage: 'Survey Templates Intl Heading',
    desc: TYPE_HEADER,
  },
  survey_templates_intl_tooltip: {
    id: 'PricingSummary.Feature.SurveyTemplatesIntlTooltip',
    defaultMessage: 'Survey Templates Intl tooltip',
    desc: TYPE_PARAGRAPH,
  },
  surveys_read_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveysReadTooltipHeading',
    defaultMessage: 'Surveys Read Heading',
    desc: TYPE_HEADER,
  },
  surveys_read_tooltip: {
    id: 'PricingSummary.Feature.SurveysReadTooltip',
    defaultMessage: 'Surveys Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  surveys_write_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveysWriteTooltipHeading',
    defaultMessage: 'Surveys Write Heading',
    desc: TYPE_HEADER,
  },
  surveys_write_tooltip: {
    id: 'PricingSummary.Feature.SurveysWriteTooltip',
    defaultMessage: 'Surveys Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  team_activity_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamActivityTooltipHeading',
    defaultMessage: 'Team activity',
    desc: TYPE_HEADER,
  },
  team_activity_tooltip: {
    id: 'PricingSummary.Feature.TeamActivityTooltip',
    defaultMessage: `Track all user activity in your Enterprise account, such as user logins, survey creation, survey sharing, survey exports, etc. with the ability to search and filter through audit logs.`,
    desc: TYPE_PARAGRAPH,
  },
  team_logic_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamLogicTooltipHeading',
    defaultMessage: 'Team management',
    desc: TYPE_HEADER,
  },
  team_logic_tooltip: {
    id: 'PricingSummary.Feature.TeamLogicTooltip',
    defaultMessage: `If you're the Primary Admin or Admin of a team, you can invite more people to join the team and manage existing accounts.`,
    desc: TYPE_PARAGRAPH,
  },
  team_ownership_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamOwnershipTooltipHeading',
    defaultMessage: 'Team ownership',
    desc: TYPE_HEADER,
  },
  team_ownership_tooltip: {
    id: 'PricingSummary.Feature.TeamOwnershipTooltip',
    defaultMessage: 'Choose whether you or your organization owns all the accounts within your team in SurveyMonkey.',
    desc: TYPE_PARAGRAPH,
  },
  team_themes_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamThemesTooltipHeading',
    defaultMessage: 'Shared themes',
    desc: TYPE_HEADER,
  },
  team_themes_tooltip: {
    id: 'PricingSummary.Feature.TeamThemesTooltip',
    defaultMessage: `Share custom themes with your team to stay consistent with your brand's look and feel.`,
    desc: TYPE_PARAGRAPH,
  },
  teams_can_discover_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamsCanDiscoverTooltipHeading',
    defaultMessage: 'Teams Can Discover Heading',
    desc: TYPE_HEADER,
  },
  teams_can_discover_tooltip: {
    id: 'PricingSummary.Feature.TeamsCanDiscoverTooltip',
    defaultMessage: 'Teams Can Discover tooltip',
    desc: TYPE_PARAGRAPH,
  },
  teams_can_make_discoverable_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamsCanMakeDiscoverableTooltipHeading',
    defaultMessage: 'Teams Can Make Discoverable Heading',
    desc: TYPE_HEADER,
  },
  teams_can_make_discoverable_tooltip: {
    id: 'PricingSummary.Feature.TeamsCanMakeDiscoverableTooltip',
    defaultMessage: 'Teams Can Make Discoverable tooltip',
    desc: TYPE_PARAGRAPH,
  },
  teams_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamsEnabledTooltipHeading',
    defaultMessage: 'Teams Enabled Heading',
    desc: TYPE_HEADER,
  },
  teams_enabled_tooltip: {
    id: 'PricingSummary.Feature.TeamsEnabledTooltip',
    defaultMessage: 'Teams Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  text_analysis_tooltip_heading: {
    id: 'PricingSummary.Feature.TextAnalysisTooltipHeading',
    defaultMessage: 'Advanced survey analysis',
    desc: TYPE_HEADER,
  },
  text_analysis_tooltip: {
    id: 'PricingSummary.Feature.TextAnalysisTooltip',
    defaultMessage:
      'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: TYPE_PARAGRAPH,
  },
  textbox_multiple_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.TextboxMultipleQuestionTypeTooltipHeading',
    defaultMessage: 'Textbox Multiple Question Type Heading',
    desc: TYPE_HEADER,
  },
  textbox_multiple_question_type_tooltip: {
    id: 'PricingSummary.Feature.TextboxMultipleQuestionTypeTooltip',
    defaultMessage: 'Textbox Multiple Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  try_before_you_buy_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.TryBeforeYouBuyEnabledTooltipHeading',
    defaultMessage: 'Try Before You Buy Enabled Heading',
    desc: TYPE_HEADER,
  },
  try_before_you_buy_enabled_tooltip: {
    id: 'PricingSummary.Feature.TryBeforeYouBuyEnabledTooltip',
    defaultMessage: 'Try Before You Buy Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  unlimited_questions_tooltip_heading: {
    id: 'PricingSummary.Feature.UnlimitedQuestionsTooltipHeading',
    defaultMessage: 'Questions per survey',
    desc: TYPE_HEADER,
  },
  unlimited_questions_tooltip: {
    id: 'PricingSummary.Feature.UnlimitedQuestionsTooltip',
    defaultMessage:
      'Some of our plans only allow a certain number of questions for each survey you send. All plans allow you to create and send as many surveys as you want.',
    desc: TYPE_PARAGRAPH,
  },
  unlimited_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.UnlimitedResponsesTooltipHeading',
    defaultMessage: NUM_RESPONSES,
    desc: TYPE_HEADER,
  },
  unlimited_responses_tooltip: {
    id: 'PricingSummary.Feature.UnlimitedResponsesTooltip',
    defaultMessage: NUM_RESPONSES_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  user_management_tooltip_heading: {
    id: 'PricingSummary.Feature.UserManagmentTooltipHeading',
    defaultMessage: 'Additional users',
    desc: TYPE_HEADER,
  },
  user_management_tooltip: {
    id: 'PricingSummary.Feature.UserManagmentTooltip',
    defaultMessage:
      'Business plans start at 3 Full Users, and allow you to invite more Full Users to your SurveyMonkey team for an additional fee. With a team plan, you can add Contributor seats in bundles of 2 as a cost-effective way to add stakeholders to focus solely on analyzing survey results. Enterprise plans allow you to add as many users as you need across your organization and allows for broad collaboration at scale.',
    desc: TYPE_PARAGRAPH,
  },
  users_read_tooltip_heading: {
    id: 'PricingSummary.Feature.UsersReadTooltipHeading',
    defaultMessage: 'Users Read Heading',
    desc: TYPE_HEADER,
  },
  users_read_tooltip: {
    id: 'PricingSummary.Feature.UsersReadTooltip',
    defaultMessage: 'Users Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  validate_answer_tooltip_heading: {
    id: 'PricingSummary.Feature.ValidateAnswerTooltipHeading',
    defaultMessage: 'Answer validation',
    desc: TYPE_HEADER,
  },
  validate_answer_tooltip: {
    id: 'PricingSummary.Feature.ValidateAnswerTooltip',
    defaultMessage: 'Require the text in survey responses to meet formatting and content criteria you set.',
    desc: TYPE_PARAGRAPH,
  },
  view_respondent_ip_address_tooltip_heading: {
    id: 'PricingSummary.Feature.ViewRespondentIpAddrressTooltipHeading',
    defaultMessage: `View respondent's IP address`,
    desc: TYPE_HEADER,
  },
  view_respondent_ip_address_tooltip: {
    id: 'PricingSummary.Feature.ViewRespondentIpAddrressTooltip',
    defaultMessage:
      'Automatically record the IP address of respondents to get a better sense of who answers your surveys.',
    desc: TYPE_PARAGRAPH,
  },
  webhooks_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WebhooksReadTooltipHeading',
    defaultMessage: 'Webhooks Read Heading',
    desc: TYPE_HEADER,
  },
  webhooks_read_tooltip: {
    id: 'PricingSummary.Feature.WebhooksReadTooltip',
    defaultMessage: 'Webhooks Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  webhooks_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WebhooksWriteTooltipHeading',
    defaultMessage: 'Webhooks Write Heading',
    desc: TYPE_HEADER,
  },
  webhooks_write_tooltip: {
    id: 'PricingSummary.Feature.WebhooksWriteTooltip',
    defaultMessage: 'Webhooks Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  word_cloud_combine_hide_tooltip_heading: {
    id: 'PricingSummary.Feature.WordCloudCombineHideTooltipHeading',
    defaultMessage: 'Word clouds: Combine or hide words',
    desc: TYPE_HEADER,
  },
  word_cloud_combine_hide_tooltip: {
    id: 'PricingSummary.Feature.WordCloudCombineHideTooltip',
    defaultMessage:
      'Get more control over the words that appear in your word cloud. Combine similar words, hide others, and choose the frequency of words to include.',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_members_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsMembersReadTooltipHeading',
    defaultMessage: 'Workgroups Members Read Heading',
    desc: TYPE_HEADER,
  },
  workgroups_members_read_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsMembersReadTooltip',
    defaultMessage: 'Workgroups Members Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_members_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsMembersWriteTooltipHeading',
    defaultMessage: 'Workgroups Members Write Heading',
    desc: TYPE_HEADER,
  },
  workgroups_members_write_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsMembersWriteTooltip',
    defaultMessage: 'Workgroups Members Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsReadTooltipHeading',
    defaultMessage: 'Workgroups Read Heading',
    desc: TYPE_HEADER,
  },
  workgroups_read_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsReadTooltip',
    defaultMessage: 'Workgroups Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_shares_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsSharesReadTooltipHeading',
    defaultMessage: 'Workgroups Shares Read Heading',
    desc: TYPE_HEADER,
  },
  workgroups_shares_read_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsSharesReadTooltip',
    defaultMessage: 'Workgroups Shares Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_shares_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsSharesWriteTooltipHeading',
    defaultMessage: 'Workgroups Shares Write Heading',
    desc: TYPE_HEADER,
  },
  workgroups_shares_write_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsSharesWriteTooltip',
    defaultMessage: 'Workgroups Shares Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsWriteTooltipHeading',
    defaultMessage: 'Workgroups Write Heading',
    desc: TYPE_HEADER,
  },
  workgroups_write_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsWriteTooltip',
    defaultMessage: 'Workgroups Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
});
